<div class="dialog-title" mat-dialog-title>
  {{'administration.printers.printer-history-dialog.title' | translate}}
  <button mat-icon-button mat-dialog-close>
    <fa-icon [icon]="faTimes" size="lg"></fa-icon>
  </button>
</div>

<mat-divider></mat-divider>

<div mat-dialog-content>
  <table mat-table [dataSource]="data.printerHistoryList">

    <ng-container matColumnDef="shopNumber">
      <th mat-header-cell *matHeaderCellDef> {{'common.shop-number' |
        translate}} </th>
      <td mat-cell *matCellDef="let element"> {{element.shop.shopNumber}} </td>
    </ng-container>

    <ng-container matColumnDef="shopName">
      <th mat-header-cell *matHeaderCellDef> {{'common.shop-name' | translate}}
      </th>
      <td mat-cell *matCellDef="let element"> {{element.shop.shopName}} </td>
    </ng-container>

    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef> {{'common.active' | translate}} </th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="element.isActive; then thenBlock else elseBlock"></div>
        <ng-template #thenBlock>
          <span class="icon-active">
            <fa-icon [icon]="faCheck" size="lg"></fa-icon>
          </span>
        </ng-template>
        <ng-template #elseBlock>
          <span class="icon-inactive">
            <fa-icon [icon]="faTimes" size="lg"></fa-icon>
          </span>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="dateFrom">
      <th mat-header-cell *matHeaderCellDef> {{'common.date-from' | translate}} </th>
      <td mat-cell *matCellDef="let element"> {{element.dateFrom | date:'yyyy-MM-dd HH:mm'}} </td>
    </ng-container>

    <ng-container matColumnDef="dateTo">
      <th mat-header-cell *matHeaderCellDef> {{'common.date-to' | translate}} </th>
      <td mat-cell *matCellDef="let element"> {{element.dateTo ? (element.dateTo | date:'yyyy-MM-dd HH:mm') : ('common.now' | translate)}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>